<ziro-loading-block [hidden]="!isLoading" class="m-auto"></ziro-loading-block>
@if (!isLoading) {
  <div>
    <ziro-security-group-memberships-form
      [inventory]="inventory"
      [initialEntity]="originalEntity"
      [fieldConfig]="securityGroupConfig"
      [microsoft360View]="microsoft360View"
    ></ziro-security-group-memberships-form>
  </div>
}
